/**
 * A basic Observer with subscribers.
 * Useful to extend this class to build specialist Observers for decoupled functionality, eg. Cart.
 * Very similar to Node's EventEmitter
 * At it's core, it holds arrays of functions
 */
export default class Notifier {
  constructor() {
    this.subscriptions = {};
  }

  /**
   * Subscribe to get notified when an event happens (the callback runs when it happens).
   *
   * Optionally receive data and a caller argument.
   * @param {string} type The event type to subscribe to
   * @param {Function} cb The callback that should run when notified
   */
  subscribe(type, cb) {
    if (this.subscriptions[type]) {
      this.subscriptions[type].push(cb);
    } else {
      this.subscriptions[type] = [cb];
    }
  }

  /**
   * Removes the callback function from the subscription array.
   * @param {string} type The event type that was subscribed to
   * @param {Function} cb The function that was previously passed in and stored as a subscription
   */
  unsubscribe(type, cb) {
    const funcs = this.subscriptions[type];
    if (!Array.isArray(funcs)) return;
    const funcIndex = funcs.findIndex((func) => {
      return func === cb;
    });
    if (funcIndex !== -1) this.subscriptions[type].splice(funcIndex, 1);
  }

  /**
   * Execute all callback functions subscribed to the event type
   * @param {string} type The event type
   * @param {any} data The data that should be passed to each callback function
   * @param {string} [caller] The function calling notify
   */
  notify(type, data, caller) {
    const funcsArr = this.subscriptions[type];
    if (Array.isArray(funcsArr)) {
      funcsArr.forEach((func) => {
        func(data, caller);
      });
    }
  }
}
